<template>
    <div>
        <div class="promise-content">
            <h3 class="promise-title">承 诺 书</h3>
            <div class="promise-text">
                本人承诺：在本次办理住房公积金业务过程中所填写、提交的信息和材料真实、合法、有效，如有虚假，由此引发的一切法律后果由本人承担。本人自愿按照《住房公积金管理条例》、相关部委文件以及南通市住房公积金管理中心制定的相关实施办法等规定精神，承担一切法律责任和后果：包括但不限于将个人信息列入不良信用记录，5年内不得享受住房公积金提取、贷款政策，情节严重涉嫌违法犯罪的移送司法机关处理等，并对由此引发的损失承担全部的赔偿责任。
            </div>
        </div>

	    <div v-show="target==='advanceRepayment'">
		    <van-cell title="资金来源" is-link @click="showZjly=true" :value="zjly.text" class="van-require-patch select-bank" />
		    <van-popup v-model="showZjly" position="bottom">
			    <van-picker v-if="showZjly"
			                :columns="zjlyList"
			                show-toolbar
			                title="请选择"
			                :defaultIndex="0"
			                @cancel="showZjly = false;"
			                @confirm="onConfirm($event,'zjly')"
			    >
			    </van-picker>
		    </van-popup>
	    </div>


        <div class="btn-wrap">
            <van-button type="default" size="normal" :square="true" :block="true" color="#518ede" @click="routingTo">下一步</van-button>
        </div>
    </div>
</template>

<script>
import {Button, Cell, Picker, Popup} from 'vant';
import 'vant/lib/button/style';
import 'vant/lib/cell/style';
import 'vant/lib/picker/style';
import 'vant/lib/popup/style';

    export default {
        name: 'promiseLetter',
        components: {
            vanButton: Button,
	        vanCell: Cell,
	        vanPopup: Popup,
	        vanPicker: Picker,
        },
        data(){
            return {
                target: '',

	            zjly: {id: '', text: '请选择'},
				zjlyList: [
					{id: '0', text: '公积金账户余额'},
					{id: '1', text: '代扣银行卡还款'},
				],
	            showZjly: false,

            }
        },
        created(){

        },
        mounted() {
            // alert(window.location.href);
            console.log(this.$route.query);
            // t => target
            if(this.$route.query.hasOwnProperty('t')) this.target = this.$route.query.t;
			console.log('获取的target ->', this.target);
            this.$utils.loading(false);
        },
        methods: {
	        // 提取业务银行卡校验接口
	        preCheckCard(){
		        let self = this;
		        self.$http.post('/miapp/A5010/mpaasgatewayunencrypted', {
			        ybmapMessage: {
				        grzh: self.$store.state.accountNumber.accountNumber,
				        // zjhm: self.$store.state.btUserInfo.idCard,
				        coreUserid: self.$store.state.btUserInfo.coreUserid,
				        channel: '11'
			        }
		        }).then(res => {
			        self.$utils.loading(false);
			        res = typeof res === 'string' ? JSON.parse(res) : res;
			        if(res.recode === '000000'){

			        } else {
				        self.$utils.alert(res.msg, function(){
					        self.$router.go(-1);
				        });
			        }
		        }).catch(res => {
			        self.$utils.loading(false);
			        console.log("error", res);
		        });
	        },

	        onConfirm(value, type) {
		        let self = this;
		        switch (type) {
			        case "zjly":
				        self.zjly = value;
				        self.showZjly = false;
				        break;

		        }
	        },

            routingTo(){
                let self = this;
                let target = this.target;
                if(/*target === 'repayAccumulationFund' || */ target === 'advanceRepayment' || target === 'signAgreement'){
					if(target === 'advanceRepayment'){
						if(self.zjly.id === ''){
							self.$utils.alert('请选择资金来源')
							return false;
						}
            // 直接跳转到提前还款页面中
						self.$router.push({
							path: '/advanceRepayment',
							query: {
								'openweb': 'paschybrid',
								'zjly': self.zjly.id
							}
						});
					} else {
						self.$router.push({
							path: '/LoanAccountNumberQuery',
							query: {
								'openweb': 'paschybrid',
								'link': target
							}
						});
					}


                }

				// 2023年6月15日 卡校验注释掉不上生产
				else if(
					target === 'retirement' ||
	                target === 'terminationOfContract' ||
	                target === 'buyHouse' ||
	                target === 'repayAccumulationFund'
                ){

	                self.$utils.alert(`${self.$store.state.btUserInfo.userName}您好！正在从${self.$store.state.btUserInfo.bank}银行系统校验您的银行卡（${self.$store.state.btUserInfo.cardno}），预计时间不超过1分钟，请耐心等待。若校验不通过，可通过银行卡绑定菜单绑定其他银行卡。`, function(){
		                self.$utils.loading(true);
		                self.$http.post('/miapp/H1001/mpaasgatewayunencrypted', {
			                ybmapMessage: {
				                grzh: self.$store.state.accountNumber.accountNumber,
				                // zjhm: self.$store.state.btUserInfo.idCard,
				                coreUserid: self.$store.state.btUserInfo.coreUserid,
				                channel: '11'
			                }
		                }).then(res => {
			                self.$utils.loading(false);
			                res = typeof res === 'string' ? JSON.parse(res) : res;
			                if(res.recode === '000000'){
								        // 如果是偿还公积金贷款提取，直接跳转展示页面
				                if(target === 'repayAccumulationFund'){
					                self.$router.push({
						                /*path: '/LoanAccountNumberQuery',*/
                            path: '/repayAccumulationFund',
						                query: {
							                'openweb': 'paschybrid'
						                }
					                });
				                } else {
					                self.$router.push({
						                path: '/' + target,
						                query: {
							                'openweb': 'paschybrid'
						                }
					                });
				                }

			                } else {
				                self.$utils.alert(res.msg, function(){
					                self.$router.go(-1);
				                });
			                }
		                }).catch(res => {
			                self.$utils.loading(false);
			                console.log("error", res);
		                });
	                });
                }

				else {
                    self.$router.push({
                        path: '/' + target,
                        query: {
                            'openweb': 'paschybrid'
                        }
                    });
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
body
    background #e5e5e5
</style>
<style lang="stylus" scoped>
.db
    display block
.van-cell-group__title
    color #518ede
    font-weight 400
.promise-content
    padding 0 0 .3rem
    background #ffffff
    margin-bottom .4rem
.btn-wrap
    display flex
.promise-title
    font-weight 400
    font-size .44rem
    text-align center
    display block
    padding .3rem
.promise-text
    font-size .32rem
    line-height .46rem
    color #333
    text-align justify
    text-indent 2em
    padding 0 .3rem .3rem
.servaddr
    display block
    /*position absolute
    bottom 0
    left 0*/
    z-index 3
    text-align center
    color #999
    padding .5rem 3% .2rem
    font-size .26rem
    line-height .42rem
    width 94%
.van-field__label
    width auto
    text-overflow ellipsis
    padding-right 12px
.van-require-patch
    position relative
    width 100%
    &:before
        position absolute
        left 18px
        color #ee0a24
        font-size .32rem
        content '*'
</style>